'use client'
import { Sheet, SheetTitle, SheetTrigger } from '@/components/ui/sheet'
import { useIsMobile } from '@/hooks/use-mobile'
import { useNavItems } from '@/hooks/use-navbar'
import { Globe, X } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { DesktopNavDropdownItem } from './DesktopNavItem'
import { NavSheetContent } from './Mobile/NavSheetContent'

// TODO: Refactor to language dropdown selector on desktop, with thinner icon
export function LoggedOutNav() {
  const isMobile = useIsMobile()
  const t = useTranslations('navbar')
  const { componentItems } = useNavItems()
  const [isOpen, setIsOpen] = useState(false)

  if (isMobile) {
    const languageItem = componentItems.language
    const viewItems = languageItem.children
    const Icon = isOpen ? X : Globe

    return (
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger aria-label="Toggle Menu">
          <Icon className="h-6 w-6 text-foreground" />
        </SheetTrigger>
        <NavSheetContent
          HeaderComponent={() => (
            <SheetTitle className="text-xl">{t('language')}</SheetTitle>
          )}
          items={viewItems}
          setNestedView={() => null}
        />
      </Sheet>
    )
  }

  const languageItem = componentItems.languageDropdown

  return (
    <DesktopNavDropdownItem
      item={languageItem}
      iconProps={{ color: 'white' }}
    />
  )
}
